import { useOrganizationId } from '@/features/organization/use-organization-id'
import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import { IApiError, IApiQueryParams } from '@/utils/api/api-types'
import { omit } from '@/utils/functions/omit'
import { UseQueryOptions } from '@tanstack/react-query'
import type { IOrganizationResponseData } from 'api/dist/routes/organization/[organization_id]/index.js'

export class GetDatabaseOrganizationQuery {
    static getKey(params: IApiQueryParams) {
        return ['organization', params.organizationId, 'get-database-organization']
    }

    static async call(api: IApi, params: IApiQueryParams) {
        return api.get<IOrganizationResponseData>(`/organization/${params.organizationId}`).then((res) => res.data)
    }
}

export function useGetDatabaseOrganizationQuery(
    options?: Omit<
        UseQueryOptions<IOrganizationResponseData, IApiError, IOrganizationResponseData>,
        'queryKey' | 'queryFn'
    >
) {
    const queryClient = useClientApi()
    const organizationId = useOrganizationId()

    const payload = {
        organizationId,
    }

    return useApiQuery<IOrganizationResponseData>({
        queryKey: GetDatabaseOrganizationQuery.getKey(payload),
        queryFn: () => GetDatabaseOrganizationQuery.call(queryClient, payload),
        enabled: !!organizationId && (options?.enabled ?? true),
        ...omit(options || {}, 'enabled'),
    })
}
